/**
 * @file index.js
 * @author Martin Albarracin
 * @description Video call View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './videoCallsFrameView';

export const mapStateToPropsVideoCallsFrame = mapStateToProps;
export const mapDispatchToPropsVideoCallsFrame = mapDispatchToProps;

export default connect(
  mapStateToPropsVideoCallsFrame,
  mapDispatchToPropsVideoCallsFrame
)(View);
